import React from 'react'

import moment from 'moment'


import css from '../../FondosAsignados.css'

moment.locale('es')
let PropTypes = React.PropTypes

export class RowDetalleFondo extends React.Component{
    constructor(props){
        super(props)
        this.inputOnKeyDown = this.inputOnKeyDown.bind(this)
        this.state = {
            servicio: [],
            comprobante: ''
        }
        this.onInputChange = (key, evt)=>{
            let actualizado = {}
            actualizado[key] = evt.target.type === 'checkbox'? evt.target.checked : evt.target.value
            actualizado.dirty = 1
            this.setState({ servicio: Object.assign({}, this.state.servicio, actualizado)}, ()=> this.context.inputChange(this.props.index, this.state.servicio))
        }
        this.onInputBlur =()=>{
            if(this.state.servicio.dirty)
                this.context.guardarFondo(this.state.servicio)
        }
    }
    onComprobanteChange(evt){
        if(evt.target.files[0]){
            let actualizado = {}
            actualizado.comprobante = evt.target.files[0]
            this.setState({ servicio: Object.assign({}, this.state.servicio, actualizado)}, ()=> this.context.subirComprobante(this.props.index, this.state.servicio))
        }
    }
    focusElemento(elemento){
        this[elemento].focus()
    }
    inputOnKeyDown(key, evt){
        if((evt.keyCode===9 && evt.shiftKey===false) || evt.keyCode===40 || evt.keyCode===13){
            // 9 = tab, flechaAbajo = 40,  13 = enter
            evt.preventDefault()
            this.props.focusRow(this.props.index+1, key)

        }else if((evt.keyCode===9 && evt.shiftKey===true) || evt.keyCode===38) {
            // flechaArriba = 38, shift+tab
            evt.preventDefault()
            this.props.focusRow(this.props.index-1, key)
        }
    }
    componentWillMount(){
        this.setState({
            servicio: this.props.servicio
        })
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* Dia */}
                <td className={css.tdDia}>
                    <div>
                        {this.props.totales? null : moment(this.state.servicio.dia).format('dddd D MMM')}
                    </div>
                </td>
                {/* Cantidad Servicios */}
                <td className={css.tdServicios}>
                    <div className={"text-left "+css.totales}>
                        {this.props.totales?
                            <strong>Totales</strong>
                            :
                            this.state.servicio.cantidad_servicios
                        }
                    </div>
                </td>
                {/* Colacion Noche */}
                <td className={css.tdColNoche}>
                    {
                        this.props.totales?
                            <div className={"text-left "+css.totales}>
                                <strong>{this.props.totalColacionNocturna.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                            :
                            <div>
                                {this.state.servicio.colacion_nocturna.toLocaleString("es-CL", {style: "currency", currency: "clp"})}
                            </div>
                    }
                </td>
                {/* Viático */}
                <td className={css.tdViatico}>
                    {
                        this.props.totales?
                            <div className={"text-left "+css.totales}>
                                <strong>{this.props.totalViatico.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                            :
                            <div>
                                {this.state.servicio.viatico.toLocaleString("es-CL", {style: "currency", currency: "clp"})}
                            </div>
                    }
                </td>
                {/* Acercamiento */}
                <td className={css.tdAcercamiento}>
                    {
                        this.props.totales?
                            <div className={"text-left "+css.totales}>
                                <strong>{this.props.totalAcercmientos.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                            :
                            <div>
                                {this.state.servicio.acercamientos.toLocaleString("es-CL", {style: "currency", currency: "clp"})}
                            </div>
                    }
                </td>
                {/* Traslados */}
                <td className={css.tdTraslado}>
                    {
                        this.props.totales?
                            <div className={"text-left "+css.totales}>
                                <strong>{this.props.totalTraslados.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                            :
                            <div>
                                {this.state.servicio.traslados.toLocaleString("es-CL", {style: "currency", currency: "clp"})}
                            </div>
                    }
                </td>
                {/* Pasaje Operador */}
                <td className={css.tdPasajeOperador}>
                    {
                        this.props.totales?
                            <div className={"text-left "+css.totales}>
                                <strong>{this.props.totalPasajeOperador.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                            :
                            <div>
                                {this.state.servicio.pasajeOperador.toLocaleString("es-CL", {style: "currency", currency: "clp"})}
                            </div>
                    }
                </td>
                {/* Otros */}
                <td className={css.tdOtros}>
                    {
                        this.props.totales?
                            <div className={"text-left "+css.totales}>
                                <strong>{this.props.totalOtros.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                            :
                            <div>
                                {this.state.servicio.otros.toLocaleString("es-CL", {style: "currency", currency: "clp"})}
                            </div>
                    }
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/distribucion/RowDetalleFondo.jsx